import { Component } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { ApporvalsIcon, ApprovalCardsIcon } from '../../../../svgIcons';
import { StudentAdmissionChangeUtils } from '../utils';

class ApprovalRequestsDialog extends Component {
    renderFooter = () => {
        const { onCancel } = this.props;
        
        return (
            <div className="flex flex justify-content-center my-3">
                <Button 
                    className="cancelButtonn" 
                    style={{ width: "336px", height: "48px" }} 
                    onClick={onCancel}
                >
                    <p className="cancelButtonnText">Cancel</p>
                </Button>
            </div>
        );
    };

    render() {
        const { 
            visible, 
            onHide, 
            admissionChangeCheckResponse, 
            message 
        } = this.props;

        return (
            <Dialog
                className='approvalsDialog'
                resizable={false}
                visible={visible}
                style={{ width: '80%', height: "80%" }}
                draggable={false}
                closable={true}
                onHide={onHide}
                footer={this.renderFooter}
            >
                <div className="">
                    <div className='flex flex-column align-items-center mb-2'>
                        <ApporvalsIcon />
                        <h4 className='pending-title'>Approval Requests Pending</h4>
                        <span className="header-msg" style={{ color: "#4E616B" }}>{message}</span>
                    </div>

                    {admissionChangeCheckResponse && admissionChangeCheckResponse.length > 0 && (
                        <div>
                            <div className="grid mt-3 mx-5">
                                {admissionChangeCheckResponse.map((item, index) => (
                                    <div key={index} className="col-12 md:col-4">
                                        <div className="p-3 border-1 border-round-lg surface-border mb-2 approval-card">
                                            <div className="flex align-items-center">
                                                <div className="w-3rem h-3rem flex align-items-center justify-content-center mr-3">
                                                    <ApprovalCardsIcon />
                                                </div>
                                                <div>
                                                    <div className="approval-card-header text-900 font-medium mb-1">
                                                        {StudentAdmissionChangeUtils.capitalizeFirstLetter(item.type)}
                                                    </div>
                                                    <div className="text-600">
                                                        {item.count} {item.count > 1 ? 'Requests' : 'Request'} Pending
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div className="mt-2 mx-5">
                                <i className="pi pi-info-circle mx-2"></i>
                                <span className="info-text">
                                    You must resolve these pending requests before proceeding with the admission change.
                                </span>
                            </div>
                        </div>
                    )}
                </div>
            </Dialog>
        );
    }
}

export default ApprovalRequestsDialog;
